import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ResponseObject } from 'src/app/models/response-object.model';
import { TaxService } from 'src/app/services/tax.service';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';
import { ChangeFormTaxResponse, FormTaxResponse, HistoryTaxResponse, SearchTopProvider } from 'src/app/models/tax.model';
import { CopyUtil, DateUtil } from 'src/app/common/util';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { UserSaved } from 'src/app/models/user.model';

@Component({
  selector: 'app-tax-form-list',
  templateUrl: './tax-form-list.component.html',
  styleUrls: ['./tax-form-list.component.scss']
})
export class TaxFormListComponent implements OnInit, OnDestroy {
  filter: string = "";
  month: number = 1;
  year: number = 2024;
  size: number = 10;
  status: number = undefined;
  type: number = 1;
  years = [2023, 2024];
  sizes = [10, 20, 30, 40, 50, 80, 100];
  listStatus: { value: number, name: string, code: any }[] = [];
  listForms: FormTaxResponse[] = [];
  filterForms: FormTaxResponse[] = [];
  months = {
    1: "Enero",
    2: "Febrero",
    3: "Marzo",
    4: "Abril",
    5: "Mayo",
    6: "Junio",
    7: "Julio",
    8: "Agosto",
    9: "Septiembre",
    10: "Octubre",
    11: "Noviembre",
    12: "Diciembre"
  }
  timeout = null;
  got = false;
  seeing = null;
  buttonOkayStep = new ButtonLoading("btn-success", false, "", "fa-gavel");
  buttonErrorStep = new ButtonLoading("btn-danger", false, "", "fa-gavel");
  pdf: File | null = null;
  searchTopProvider: SearchTopProvider = null;
  user: UserSaved = null;

  constructor(
    private taxService: TaxService,
    private toastService: ToastrService,
    private authService: AuthenticationService
  ) {
    authService.setCurrentCompanyId(809);
    this.user = authService.getUser();
  }

  ngOnInit(): void {
    this.getStatusByType();
  }

  searching() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.filtering();
    }, 300)
  }

  showTopProvider(form: FormTaxResponse) {
    this.searchTopProvider = new SearchTopProvider(form.companyId, form.monthStart, form.year);
  }

  onFileChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.files?.length) {
      this.pdf = inputElement.files[0];
    }
  }

  workOneForm(form: FormTaxResponse, okay: boolean = true) {
    if (this.buttonErrorStep.loading || this.buttonOkayStep.loading) {
      return;
    }
    this.buttonOkayStep.loading = true;
    this.buttonErrorStep.loading = true;
    var temp = new ChangeFormTaxResponse();
    temp.accessories = form.accessories;
    temp.description = form.description;
    if (okay) {
      temp.expirationDate = form.status === 10 ? DateUtil.parseToMilliDateTime(form.expirationDateAux) : null;
    } else {
      temp.expirationDate = null;
    }
    temp.hasErrors = !okay;
    temp.formAccess = form.formAccess;
    temp.formId = form.id;
    temp.formNumber = form.formNumber;
    temp.taxesToPay = form.taxesToPay;
    this.taxService.changeFormTax(
      form.id,
      temp
    ).subscribe({
      next: (response: ResponseObject) => {
        if ((form.status === 20 || (form.status === 30 && this.pdf !== null)) && okay) {
          this.taxService.uploadFile(this.pdf, form.id, form.description).subscribe({
            next: (response: ResponseObject) => {
              this.toastService.success("Cambios y pdf guardados correctamente!");
              this.buttonOkayStep.loading = false;
              this.buttonErrorStep.loading = false;
              this.pdf = null;
              this.getFormsByMonthYearStatusAndType();
            },
            error: (error: HttpErrorResponse) => {
              this.toastService.info("Cambios guardados y error al guardar el pdf!");
            }
          })
        } else {
          this.toastService.success("Cambios guardados correctamente!");
          this.buttonOkayStep.loading = false;
          this.buttonErrorStep.loading = false;
          this.getFormsByMonthYearStatusAndType();
        }
      }
      ,
      error: (error: HttpErrorResponse) => {
        this.buttonOkayStep.loading = false;
        this.buttonErrorStep.loading = false;
        this.toastService.error(error.error.message);
      }
    })
  }

  getNextOkayStep(form) {
    var statusText = '';
    switch (form.status) {
      case 10:
        statusText = 'Declarar';
        break;
      case 20:
        statusText = 'Declarar Aprobado';
        break;
      case 21:
        statusText = 'Pagar';
        break;
      case 30:
        statusText = 'Terminar';
        break;
    }
    return statusText;
  }

  getNextErrorStep(form) {
    var statusText = '';
    switch (form.status) {
      case 20:
        statusText = 'Declarar con Errores';
        break;
      case 30:
        statusText = 'Pagar con Errores';
        break;
    }
    return statusText;
  }

  filtering() {
    this.seeing = null;
    if (this.filter) {
      var filter = this.filter.toLowerCase();
      this.filterForms = this.listForms.filter((form) => {
        return form.companyName.toLowerCase().includes(filter) || form.companyNit.toLowerCase().includes(filter)
          || form.companyCode.toLowerCase().includes(filter);
      })
    } else {
      this.filterForms = this.listForms;
    }
  }

  getStatusByType() {
    this.taxService.getStatusByType(this.type).subscribe({
      next: (response: ResponseObject) => {
        this.listStatus = response.data;
        this.status = this.listStatus[0].value;
        this.getFormsByMonthYearStatusAndType();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  getDetail(form: FormTaxResponse) {
    if (!form.history) {
      this.taxService.getHistoryTax(
        form.id
      ).subscribe({
        next: (response: ResponseObject) => {
          form.history = response.data as HistoryTaxResponse[];
          this.seeing = form.id;
        }
        ,
        error: (error: HttpErrorResponse) => {
          this.toastService.error(error.error.message);
        }
      })
    } else {
      this.seeing = form.id;
    }
  }

  getFormsByMonthYearStatusAndType() {
    this.seeing = null;
    this.taxService.getFormsByMonthYearStatusAndType(
      this.year,
      this.month,
      this.status,
      this.type,
      this.user.contadorGT
    ).subscribe({
      next: (response: ResponseObject) => {
        this.listForms = response.data;
        this.listForms.forEach((form) => {
          if (form.expirationDate) {
            form.expirationDateAux = new Date(form.expirationDate).toLocaleDateString('en-CA');
          } else {
            form.expirationDateAux = null;
          }
        })
        this.got = true;
        this.filtering();
      }
      ,
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  copy(text) {
    CopyUtil.copy(text);
    this.toastService.info("Copiado al portapapeles!");
  }

  ngOnDestroy(): void {
    localStorage.removeItem('inin-company');
  }
}
